import { render, staticRenderFns } from "./InstitutionSettingsTimeblocks.vue?vue&type=template&id=022a0acf&"
import script from "./InstitutionSettingsTimeblocks.vue?vue&type=script&lang=js&"
export * from "./InstitutionSettingsTimeblocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports